import { createAsyncThunk } from '@reduxjs/toolkit'
import { DigibonAPI } from '../../../api/digibon'

export const setStations = createAsyncThunk('station/setStations', async () => {
    return await DigibonAPI.fetchStations()
})
